import {navigationContainer} from '@wallaby-ui/core';
import {get} from 'lodash';
import {filterAndSearchSlice} from 'src/js/containers/filter_and_search/filter_and_search_slice';
import {changeQueryParams} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {
  GRID_SORT_MODEL_SORT_COLUMN,
  GRID_SORT_MODEL_SORT_DIRECTION,
} from 'src/js/containers/grid/grid_constants';
import {DEFAULT_REPORTS_PAGE_SIZE} from 'src/js/containers/reports/reports_constants';
import {AppThunk} from 'src/js/store';

import {reportsSlice} from './reports_slice';

// TODO-JK: delete
// export function changeReportParamsAndQuery(
//   stateId,
//   reportId,
//   gridParams,
//   gridId,
//   detailId,
//   filterAndSearchStateId,
//   requestUrl,
//   urlParams
// ) {
//   return (dispatch) =>
//     Promise.all([
//       dispatch(
//         reportsSlice.actions.changeReportParams(stateId, {
//           params: gridParams,
//           gridId,
//         })
//       ),
//     ]).then(() =>
//       dispatch(
//         changeParamsAndQuery(filterAndSearchStateId, requestUrl, urlParams)
//       )
//     );
// }

export function loadStateFromParams(
  stateId,
  filterAndSearchStateId,
  reportId
): AppThunk {
  return (dispatch, getState) => {
    const state = getState();

    let promises;
    const {reportsConfig} = state[stateId];
    if (reportsConfig.isPaging()) {
      // TODO-JK: we dont use paging report at the moment
      // // paged report is single one in reports config
      // const reportConfig = reportsConfig.getReports()[0];
      // // default page size
      // const defaultPagination = reportConfig
      //   .getOptions()
      //   .getTableConfig()
      //   .getDefaultPagination();
      // const defaultSize =
      //   (defaultPagination && defaultPagination.size) ||
      //   DEFAULT_REPORTS_PAGE_SIZE;
      //
      // // params from location query
      // let {page, size, sort} = getRouterLocationQuery(state);
      // let sortModel;
      // page = page ? parseInt(page, 10) : 1;
      // size = size ? parseInt(size, 10) : defaultSize;
      // if (sort) {
      //   const sortSplitted = sort.split(',');
      //   sort = sortSplitted.length === 2 ? sort : '';
      //   sortModel = [
      //     {
      //       [GRID_SORT_MODEL_SORT_COLUMN]: sortSplitted[0],
      //       [GRID_SORT_MODEL_SORT_DIRECTION]: sortSplitted[1],
      //     },
      //   ];
      // }
      // sort = sort || '';
      //
      // promises = [
      //   dispatch(
      //     changeQueryParams(filterAndSearchStateId, {
      //       page,
      //       size,
      //       sort,
      //     })
      //   ),
      //   // if sort is defined, init sort model in reports grid params
      //   ...(sortModel
      //     ? [
      //         dispatch(
      //           reportsSlice.actions.changeReportParams(stateId, {
      //             params: {sort: sortModel},
      //             gridId: reportConfig.getId(),
      //           })
      //         ),
      //       ]
      //     : []),
      //   dispatch(
      //     filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
      //       reports: false,
      //     })
      //   ),
      // ];
    } else {
      promises = [
        dispatch(
          filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
            reports: false,
          })
        ),
      ];
    }

    Promise.all(promises).then(() =>
      Promise.all([
        dispatch(reportsSlice.actions.locationParsed(stateId, true)),
        dispatch(reportsSlice.actions.resetReload(stateId)),
      ]).then(() =>
        dispatch(
          filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
            reports: true,
          })
        )
      )
    );
  };
}

export function loadReportsConfig(
  stateId: string,
  configPath: string,
  reload: boolean = false
) {
  return (dispatch, getState, {config}) => {
    const configRaw = get(config, configPath);

    dispatch(
      reportsSlice.actions.setReportsConfig(stateId, {
        config: configRaw,
        reload,
      })
    );
  };
}

// TODO-JK: delete
// export function initReportParams(
//   stateId,
//   reportId,
//   gridId,
//   detailId,
//   params = {}
// ) {
//   return (dispatch) =>
//     dispatch({
//       type: at.INIT_REPORTS_PARAMS,
//       payload: {
//         reportId,
//         gridId,
//         detailId,
//         params,
//       },
//       stateId,
//     });
// }
